/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {PasskeyLoginOptionsMutation, PasskeyLoginOptionsMutationVariables} from '../types';

export const PasskeyLoginOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PasskeyLoginOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passkeyLoginOptions"}}]}}]} as unknown as DocumentNode;
/** hook для мутации "PasskeyLoginOptions" */
export function usePasskeyLoginOptionsMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        PasskeyLoginOptionsMutation,
        PasskeyLoginOptionsMutationVariables        
    >,
) {
    return ApolloReactHooks.useMutation<
    PasskeyLoginOptionsMutation,
    PasskeyLoginOptionsMutationVariables
    >(PasskeyLoginOptionsDocument, baseOptions ?? ({} as ApolloReactHooks.MutationHookOptions<PasskeyLoginOptionsMutation, PasskeyLoginOptionsMutationVariables>));
}
